import React from "react";
import "./VelocityValue.scss";
import classNames from "classnames";
import { ReactComponent as WarningIcon } from "src/images/warning.svg";
import { MaterialTooltip } from "src/app/components/MaterialTooltip/MaterialTooltip";
import VelocityIcon from "../VelocityIcon/VelocityIcon";
import VelocityValueTooltipContent from "./VelocityValueTooltipContent";

function VelocityContent({ value, onClick, filterMatchSummary }) {
  return (
    <button
      className={classNames("velocity-value button-style-reset", {
        "velocity-value--high": (value || 0) > 50,
        "velocity-value--low": (value || 0) === 0,
        "velocity-value--no-click": typeof onClick !== "function",
      })}
      onClick={onClick}
      type="button"
    >
      {filterMatchSummary?.doesResultMatchAllFilters === false && (
        <WarningIcon
          className="velocity-value__warning"
          height={20}
          width={20}
        />
      )}
      <VelocityIcon percent={value || 0} />
      {value || 0}
    </button>
  );
}

function VelocityValue({
  value,
  onClick,
  filterMatchSummary,
  isVelocitySummaryModalOpen,
}) {
  return (
    <div className="velocity-value-wrapper">
      {filterMatchSummary &&
      filterMatchSummary.matches.length > 0 &&
      !isVelocitySummaryModalOpen ? (
        <MaterialTooltip
          className="velocity-value-tooltip"
          clickable
          content={
            <VelocityValueTooltipContent
              value={value}
              filterMatchSummary={filterMatchSummary}
            />
          }
          contentClassName="velocity-value-tooltip__content"
        >
          <VelocityContent
            value={value}
            onClick={onClick}
            filterMatchSummary={filterMatchSummary}
          />
        </MaterialTooltip>
      ) : (
        <VelocityContent
          value={value}
          onClick={onClick}
          filterMatchSummary={filterMatchSummary}
        />
      )}
    </div>
  );
}

export default VelocityValue;
